import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "edit" }
const _hoisted_2 = { class: "edit-name" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "edit-title" }, "Group Name", -1)
const _hoisted_4 = { class: "edit-info" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "edit-title" }, "Group Info", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_input, {
        modelValue: _ctx.input,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input) = $event)),
        disabled: "",
        placeholder: "Seattle team"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_el_input, {
        modelValue: _ctx.input,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.input) = $event)),
        disabled: "",
        placeholder: "This group includes everyone who works at the Seattle Location"
      }, null, 8, ["modelValue"])
    ])
  ]))
}